const confidentialityTranslation: any = {
  title: {
    fr: "Politique de confidentialité",
    ar: "سياسة الخصوصية",
    en: "Privacy Policy",
  },
  subtitle: {
    fr: "La présente charte s'applique à toutes les données à caractère personnel traitées par la société AMPHITECH agissant en qualité de responsables de traitement dans le cadre des produits et services fournis à des clients professionnels et entreprises. Elle explique quelles données nous sommes susceptibles de collecter vous concernant ou relatives aux personnes liées, de quelle manière nous utilisons ces données et quelles mesures nous prenons pour nous assurer de leur confidentialité et de leur sécurité. Elle précise également le cadre général des traitements de données à caractère personnel réalisés au sein de la société AMPHITECH et, en ce sens, a pour objectif de fournir aux personnes concernées les informations nécessaires au parfait respect de la règlementation en vigueur. Toutes les personnes physiques dont vous nous transmettez les données doivent être informées, notamment au travers de cette charte de la façon dont nous sommes susceptibles de collecter et traiter leurs données. Ces personnes doivent notamment être informées de leurs droits.",
    ar: "تنطبق هذه السياسة على جميع البيانات الشخصية التي تعالجها AMPHITECH بصفتها متحكمًا في البيانات فيما يتعلق بالمنتجات والخدمات المقدمة للعملاء المحترفين والتجاريين. وهي تشرح البيانات التي من المحتمل أن نجمعها فيما يتعلق بك أو بالأشخاص ذوي الصلة، وكيف نستخدم هذه البيانات والتدابير التي نتخذها لضمان سريتها وأمنها. كما تحدد أيضًا الإطار العام لمعالجة البيانات الشخصية التي تتم داخل AMPHITECH، وبهذا المعنى، تهدف إلى تزويد الأشخاص المعنيين بالمعلومات اللازمة للامتثال الكامل للوائح السارية. يجب إبلاغ جميع الأفراد الذين ترسل بياناتهم إلينا، ولا سيما من خلال هذا الميثاق، بالطريقة التي من المحتمل أن نجمع بها بياناتهم ونعالجها. وعلى وجه الخصوص، يجب إبلاغ هؤلاء الأفراد بحقوقهم.",
    en: "This policy applies to all personal data processed by AMPHITECH as data controllers in connection with products and services provided to professional clients and businesses. It explains what data we may collect about you or related individuals, how we use this data, and what measures we take to ensure its confidentiality and security. It also sets out the general framework for personal data processing within AMPHITECH and, as such, aims to provide individuals with the necessary information to fully comply with applicable regulations. All individuals whose data you provide to us must be informed, including through this policy, of how we may collect and process their data. These individuals should particularly be informed of their rights.",
  },
  oneTitle: {
    fr: "1. Comment vos données personnelles sont-elles collectées, conservées et traitées ? Les données personnelles collectées",
    ar: "كيف يتم جمع بياناتك الشخصية وتخزينها ومعالجتها؟ ,البيانات الشخصية التي تم جمعها",
    en: "1. How are your personal data collected, stored, and processed? The personal data collected",
  },
  oneText: {
    fr: (
      <>
        Certaines des informations recueillies constituent des « Données à
        caractère Personnel », à savoir toutes les informations qui permettent
        d&apos;identifier directement ou indirectement une personne physique. En
        conformité avec la législation en vigueur, la société AMPHITECH a adopté
        le principe de minimisation dans la collecte et ne collecte que les
        données strictement nécessaires à l&apos;objectif poursuivi et explicité
        auprès des personnes physiques concernées, en leur laissant toute
        capacité d&apos;exercice de leurs droits. Informations que vous
        fournissez lorsque vous créez un compte ou effectuez un achat :Les
        données à caractère personnel susceptibles d&apos;être demandées, en
        fonction de la nature des services ou produits fournis, sont les
        suivantes : Votre nom et vos coordonnées, y compris vos adresses
        électronique ou l&apos;entreprise dans laquelle vous travaillez, Vos
        numéros de téléphone etc, le cas échéant : Informations que vous
        fournissez lorsque vous contactez le service client : Lorsque vous
        envoyez une demande de contact via notre site internet, Conformément au
        règlement de protection de données CNDP, nous utilisons les données
        personnelles que vous nous fournissez par notre formulaire de contact
        telles que votre adresse e-mail, votre nom et votre numéro de téléphone
        afin de répondre à vos questions.
      </>
    ),
    ar: (
      <>
        تشكل بعض المعلومات التي يتم جمعها ”بيانات شخصية“، أي أي معلومات تحدد
        بشكل مباشر أو غير مباشر هوية الشخص الطبيعي. وامتثالاً للتشريعات المعمول
        بها، اعتمدت AMPHITECH مبدأ التقليل من جمع البيانات إلى أدنى حد ممكن، ولا
        تجمع سوى البيانات الضرورية للغاية للهدف المنشود وتوضيحها للأشخاص
        الطبيعيين المعنيين، مع تركهم يتمتعون بالقدرة الكاملة على ممارسة حقوقهم.
        المعلومات التي تقدمها عند إنشاء حساب أو إجراء عملية شراء: البيانات
        الشخصية التي من المحتمل أن يتم طلبها، اعتمادًا على طبيعة الخدمات أو
        المنتجات المقدمة، هي كما يلي اسمك وتفاصيل الاتصال بك، بما في ذلك عناوين
        البريد الإلكتروني أو الشركة التي تعمل بها، وأرقام هواتفك وما إلى ذلك،
        حيثما ينطبق ذلك: المعلومات التي تقدمها عند الاتصال بخدمة العملاء: عندما
        ترسل طلب اتصال عبر موقعنا الإلكتروني، وفقًا للوائح حماية البيانات الخاصة
        بالمجلس الوطني لحماية البيانات، فإننا نستخدم البيانات الشخصية التي
        تقدمها عبر نموذج الاتصال الخاص بنا، مثل عنوان بريدك الإلكتروني واسمك
        ورقم هاتفك، من أجل الإجابة عن أسئلتك.
      </>
    ),
    en: (
      <>
        Some of the information collected constitutes "Personal Data," meaning
        any information that directly or indirectly identifies an individual. In
        compliance with applicable legislation, AMPHITECH has adopted the
        principle of data minimization, collecting only the data strictly
        necessary for the specified purpose, as outlined to the relevant
        individuals, allowing them full rights to exercise their options.
        Information you provide when creating an account or making a purchase:
        Personal data that may be requested, depending on the nature of services
        or products provided, includes: Your name and contact details, including
        email addresses or the company you work for, and phone numbers if
        applicable. Information provided when contacting customer service: When
        you submit a contact request via our website, we use the personal data
        you provide in our contact form, such as your email address, name, and
        phone number, to respond to your inquiries.
      </>
    ),
  },
  twoTitle: {
    fr: "2. Pourquoi collectons nous ces informations ?",
    ar: "2. لماذا نجمع هذه المعلومات؟",
    en: "2. Why do we collect this information?",
  },
  twoText: {
    fr: (
      <>
        Nous utilisons les informations que nous collectons à votre sujet aux
        fins suivantes : effectuer les opérations relatives à la gestion des
        clients concernant : les contrats ; les commandes ; les livraisons ; les
        factures ; la Compatibilité et en particulier la gestion des comptes
        clients ; le suivi de la relation client tel que la réalisation
        d&apos;enquêtes de satisfaction, la gestion des réclamations et du
        service après-vente
      </>
    ),
    ar: (
      <>
        نحن نستخدم المعلومات التي نجمعها عنك للأغراض التالية: لتنفيذ العمليات
        المتعلقة بإدارة العملاء فيما يتعلق بما يلي: العقود؛ الطلبات؛ عمليات
        التسليم؛ الفواتير؛ المحاسبة وخاصة إدارة حسابات العملاء؛ مراقبة علاقات
        العملاء مثل إجراء استطلاعات الرأي الخاصة بالرضا وإدارة الشكاوى وخدمة ما
        بعد البيع;
      </>
    ),
    en: (
      <>
        We use the information we collect about you for the following purposes:
        to carry out operations related to customer management, including:
        contracts; orders; deliveries; invoices; accounting, and in particular,
        customer account management; monitoring of customer relations, such as
        conducting satisfaction surveys, managing complaints, and providing
        after-sales service.
      </>
    ),
  },
  threeTitle: {
    fr: "3. Qui a accès à vos données personnelles ?",
    ar: "3. من لديه حق الوصول إلى بياناتك الشخصية؟",
    en: "3. Who has access to your personal data?",
  },
  threeText: {
    fr: (
      <>
        Nous limitons l&apos;accès à vos informations aux seuls employés qui ont
        besoin de les utiliser. Ils ont l&apos;obligation de les protéger et
        d&apos;en préserver la confidentialité.
        <br />
        <br />
        Seul les personnes avec lesquelles vous avez partagé votre profil
        Popcard ont accès aux informations y figurant. Aucun autre moyens
        n&apos;existe pour accéder a votre profile car tous les liens sont
        crypté et non référencé sur les moteurs de recherches ‍
      </>
    ),
    ar: (
      <>
        نحن نقصر الوصول إلى معلوماتك على الموظفين الذين يحتاجون إلى استخدامها.
        وهم ملزمون بحمايتها والحفاظ على سريتها.
        <br />
        <br />
        الأشخاص الذين قمت بمشاركة ملفك الشخصي على Popcard معهم هم فقط من يمكنهم
        الوصول إلى المعلومات الواردة فيه. لا توجد أي وسيلة أخرى للوصول إلى ملفك
        الشخصي حيث أن جميع الروابط مشفرة ولا يتم الرجوع إليها بواسطة محركات
        البحث.
      </>
    ),
    en: (
      <>
        We restrict access to your information to only those employees who need
        to use it. They are required to protect it and maintain its
        confidentiality.
        <br />
        <br />
        Only individuals with whom you have shared your Popcard profile have
        access to the information it contains. No other means exist to access
        your profile, as all links are encrypted and not referenced by search
        engines.
      </>
    ),
  },
  fourTitle: {
    fr: "4. Comment et combien de temps les données sont-elles stockées ?",
    ar: "4. كيف ولأي مدة يتم تخزين البيانات؟",
    en: "4. How and for how long are data stored?",
  },
  fourText: {
    fr: (
      <>
        AMPHITECH prend toutes précautions utiles afin de préserver la sécurité
        et la confidentialité des données à caractère personnel et notamment
        d&apos;empêcher qu&apos;elles ne soient déformées, endommagées ou que
        des tiers non autorisés y aient accès. Vos informations personnelles
        sont conservées le temps nécessaire à la réalisation des fins pour
        lesquelles elle sont été fournies. La durée maximum de conservation de
        vos données est de deux ans à compter de la fin de la relation
        contractuelle. Toutefois, la AMPHITECH conserve certains documents
        obligatoires, notamment les factures pour la durée légale de
        conservation.
      </>
    ),
    ar: (
      <>
        تتخذ شركة AMPHITECH جميع الاحتياطات اللازمة للحفاظ على أمن وسرية
        البيانات الشخصية وعلى وجه الخصوص لمنع تشويهها أو تلفها أو الوصول إليها
        من قبل أطراف ثالثة غير مصرح لها. يتم الاحتفاظ ببياناتك الشخصية للوقت
        اللازم لتحقيق الأغراض التي قُدمت من أجلها. سيتم الاحتفاظ ببياناتك لمدة
        عامين كحد أقصى من نهاية العلاقة التعاقدية. ومع ذلك، تحتفظ AMPHITECH ببعض
        المستندات الإلزامية، ولا سيما الفواتير، لفترة الاحتفاظ القانونية.
      </>
    ),
    en: (
      <>
        AMPHITECH takes all necessary precautions to ensure the security and
        confidentiality of personal data, particularly to prevent it from being
        altered, damaged, or accessed by unauthorized third parties. Your
        personal information is kept for as long as needed to achieve the
        purposes for which it was provided. The maximum retention period for
        your data is two years from the end of the contractual relationship.
        However, AMPHITECH retains certain mandatory documents, such as
        invoices, for the legally required retention period.
      </>
    ),
  },
  fiveTitle: {
    fr: "5. Quels sont vos droits en matière d'accès à vos informations personnelles et de contrôle de leur utilisation ?",
    ar: "5. ما هي الحقوق التي لديك للوصول إلى معلوماتك الشخصية والتحكم في كيفية استخدامها؟",
    en: "5. What are your rights regarding access to your personal information and control over its use?",
  },
  fiveText: {
    fr: (
      <>
        Vous pouvez, à tout moment, demander et obtenir les informations
        suivantes : • l&apos;accès à vos informations personnelles ; • demander
        un exemplaire des informations personnelles traitées par nos soins ; •
        exiger la correction de vos informations personnelles collectées et
        conservées ; • exiger la suppression de vos informations personnelles
        (ou leur modification de telle manière que vous ne soyez plus
        identifiable) ou limiter les façons dont nous pouvons utiliser vos
        informations personnelles dans les circonstances spécifiques prévues par
        la loi.
      </>
    ),
    ar: (
      <>
        يمكنك في أي وقت طلب المعلومات التالية والحصول عليها - الوصول إلى
        معلوماتك الشخصية؛ - طلب الحصول على نسخة من المعلومات الشخصية التي نقوم
        بمعالجتها؛ - طلب تصحيح معلوماتك الشخصية التي تم جمعها والاحتفاظ بها؛ -
        طلب حذف معلوماتك الشخصية (أو تعديلها بطريقة لا يمكن معها التعرف عليك بعد
        ذلك) أو تقييد الطرق التي قد نستخدم بها معلوماتك الشخصية في الظروف
        المحددة التي ينص عليها القانون.
      </>
    ),
    en: (
      <>
        You can request and obtain the following information at any time: •
        access to your personal information; • request a copy of the personal
        information we process; • require correction of your collected and
        retained personal information; • require deletion of your personal
        information (or modification so you are no longer identifiable) or
        restrict how we can use your personal information in specific
        circumstances provided by law.
      </>
    ),
  },
  sixTitle: {
    fr: "6. A qui s'adresser pour avoir des informations ?",
    ar: "6. بمن يجب أن أتصل للحصول على معلومات؟",
    en: "6. Who to contact for information?",
  },
  sixText: {
    fr: (
      <>
        Toute demande liée à l&apos;exercice de vos droits d&apos;accès,
        d&apos;opposition, de rectification et de suppression doit être envoyée
        à l&apos;adresse contact@getpocard.com. Veuillez indiquer vos nom,
        adresse e-mail et numéro de téléphone, ainsi que votre demande précise.
        Votre demande sera traitée dans les meilleurs délais par le service
        client de Popcard.
      </>
    ),
    ar: (
      <>
        يجب إرسال أي طلب يتعلق بممارسة حقوقك في الوصول والمعارضة والتصحيح والحذف
        إلى contact@getpocard.com. يُرجى الإشارة إلى اسمك وعنوان بريدك
        الإلكتروني ورقم هاتفك، بالإضافة إلى طلبك الدقيق. سيتم التعامل مع طلبك في
        أسرع وقت ممكن من قبل خدمة عملاء Popcard.
      </>
    ),
    en: (
      <>
        Any request related to exercising your rights of access, opposition,
        rectification, and deletion should be sent to contact@getpocard.com.
        Please include your name, email address, phone number, and specific
        request. Your request will be processed promptly by the Popcard customer
        service team.
      </>
    ),
  },
  sevenTitle: {
    fr: "7. Limitation contractuelles sur les données :",
    ar: "7. القيد التعاقدي على البيانات :",
    en: "7. Contractual limitations on data:",
  },
  sevenText: {
    fr: (
      <>
        Tout le contenu du présent sur le site www.getpopcard.com, incluant, de
        façon non limitative, les graphismes, images produits, textes, vidéos,
        animations, sons, logos, gifs et icônes ainsi que leur mise en forme
        sont la propriété exclusive de la société à l'exception des marques,
        logos ou contenus appartenant à d'autres sociétés partenaires ou
        auteurs.
        <br />
        Toute reproduction, distribution, modification, adaptation,
        retransmission ou publication, même partielle, de ces différents
        éléments est strictement interdite sans l'accord exprès par écrit de
        AMPHITECH.
        <br />
        Cette représentation ou reproduction, par quelque procédé que ce soit,
        constitue une contrefaçon sanctionnée par la loi en vigueur. Le
        non-respect de cette interdiction constitue une contrefaçon pouvant
        engager la responsabilité civile et pénale du contrefacteur. En outre,
        les propriétaires des Contenus copiés pourraient intenter une action en
        justice à votre encontre.
      </>
    ),
    ar: (
      <>
        جميع المحتويات على الموقع الإلكتروني www.getpopcard.com، بما في ذلك على
        سبيل المثال لا الحصر الرسومات وصور المنتجات والنصوص ومقاطع الفيديو
        والرسوم المتحركة والأصوات والشعارات والصور المتحركة والأيقونات وكذلك
        تنسيقها، هي ملكية حصرية للشركة، باستثناء العلامات التجارية أو الشعارات
        أو المحتوى الخاص بالشركات الشريكة أو المؤلفين الآخرين.
        <br />
        ويُحظر تمامًا أي استنساخ أو توزيع أو تعديل أو تكييف أو إعادة إرسال أو
        نشر هذه العناصر المختلفة، ولو جزئيًا، دون موافقة خطية صريحة من
        AMPHITECH.
        <br />
        ويشكل مثل هذا التمثيل أو الاستنساخ، بأي وسيلة كانت، انتهاكًا يعاقب عليه
        القانون الساري. ويشكل عدم الامتثال لهذا الحظر تعديًا قد يترتب عليه
        المسؤولية المدنية والجنائية للمتعدي. بالإضافة إلى ذلك، يجوز لمالكي
        المحتوى المنسوخ اتخاذ إجراءات قانونية ضدك.
      </>
    ),
    en: (
      <>
        All content on the www.getpopcard.com site, including, but not limited
        to, graphics, product images, texts, videos, animations, sounds, logos,
        GIFs, and icons, as well as their layout, are the exclusive property of
        the company, with the exception of brands, logos, or content belonging
        to other partner companies or authors.
        <br />
        Any reproduction, distribution, modification, adaptation,
        retransmission, or publication, even partial, of these various elements
        is strictly prohibited without the express written consent of AMPHITECH.
        <br />
        Such representation or reproduction, by any means, constitutes an
        infringement punishable by law. Failure to comply with this prohibition
        may lead to civil and criminal liability for the infringer. Furthermore,
        the owners of the copied content may take legal action against you.
      </>
    ),
  },
  eightTitle: {
    fr: "8. Litiges :",
    ar: "8. المنازعات :",
    en: "8. Disputes:",
  },
  eightText: {
    fr: (
      <>
        Les présentes conditions du site www.getpopcard.com sont régies par les
        lois Marocaines et toute contestation ou litiges qui pourraient naître
        de l'interprétation ou de l'exécution de celles-ci seront de la
        compétence exclusive des tribunaux dont dépend le siège social de la
        société. La langue de référence, pour le règlement de contentieux
        éventuels, est le français.
      </>
    ),
    ar: (
      <>
        تخضع هذه الشروط والأحكام الخاصة بالموقع الإلكتروني www.getpopcard.com
        للقانون المغربي وأي نزاع أو تقاضي قد ينشأ عن تفسيرها أو تنفيذها يقع ضمن
        الاختصاص الحصري للمحاكم التي يقع مقرها المسجل للشركة. وتكون اللغة
        المرجعية لتسوية أي نزاعات هي اللغة الفرنسية.
      </>
    ),
    en: (
      <>
        The terms of the www.getpopcard.com site are governed by Moroccan law,
        and any disputes or litigation arising from their interpretation or
        execution will fall under the exclusive jurisdiction of the courts in
        the region of the company’s headquarters. The reference language for
        resolving potential disputes is French.
      </>
    ),
  },
  nineTitle: {
    fr: "9. Données personnelles :",
    ar: "9. البيانات الشخصية :",
    en: "9. Personal data:",
  },
  nineText: {
    fr: (
      <>
        De manière générale, vous n'êtes pas tenu de nous communiquer vos
        données personnelles lorsque vous visitez notre site Internet
        www.getpopcard.com. Cependant, ce principe comporte certaines
        exceptions. En effet, pour certains services proposés par notre site,
        vous pouvez être amenés à nous communiquer certaines données telles que
        : votre nom, votre fonction, le nom de votre société, votre adresse
        électronique, et votre numéro de téléphone. Tel est le cas lorsque vous
        remplissez le formulaire qui vous est proposé en ligne, dans la rubrique
        « contact ». Dans tous les cas, vous pouvez refuser de fournir vos
        données personnelles. Dans ce cas, vous ne pourrez pas utiliser les
        services du site, notamment celui de solliciter des renseignements sur
        notre société, ou de recevoir les lettres d'information. Enfin, nous
        pouvons collecter de manière automatique certaines informations vous
        concernant lors d'une simple navigation sur notre site Internet,
        notamment : des informations concernant l'utilisation de notre site,
        comme les zones que vous visitez et les services auxquels vous accédez,
        votre adresse IP, le type de votre navigateur, vos temps d'accès. De
        telles informations sont utilisées exclusivement à des fins de
        statistiques internes, de manière à améliorer la qualité des services
        qui vous sont proposés. Les bases de données sont protégées par les
        dispositions de 09-08 de la protection des données personnelles.
      </>
    ),
    ar: (
      <>
        كقاعدة عامة، لا يُطلب منك تزويدنا بأي بيانات شخصية عند زيارتك لموقعنا
        الإلكتروني www.getpopcard.com. ومع ذلك، هناك استثناءات معينة لهذا
        المبدأ. بالنسبة لخدمات معينة يقدمها موقعنا، قد يُطلب منك تزويدنا ببيانات
        معينة مثل: اسمك ومسمى وظيفتك واسم شركتك وعنوان بريدك الإلكتروني ورقم
        هاتفك. هذا هو الحال عند ملء النموذج عبر الإنترنت في قسم ”الاتصال“. في
        جميع الحالات، يمكنك رفض تقديم بياناتك الشخصية. في هذه الحالة، لن تتمكَّن
        من استخدام خدمات الموقع، ولا سيما طلب معلومات عن شركتنا أو تلقي رسائلنا
        الإخبارية. أخيرًا، قد نقوم تلقائيًا بجمع معلومات معينة عنك عندما تتصفح
        موقعنا الإلكتروني بكل بساطة، وعلى وجه الخصوص: معلومات حول استخدام
        موقعنا، مثل المناطق التي تزورها والخدمات التي تدخل إليها، وعنوان
        بروتوكول الإنترنت الخاص بك، ونوع المتصفح الذي تستخدمه وأوقات دخولك.
        تُستخدم هذه المعلومات حصريًا لأغراض إحصائية داخلية، من أجل تحسين جودة
        الخدمات المقدمة لك. قواعد البيانات محمية بموجب أحكام 09-08 بشأن حماية
        البيانات الشخصية.
      </>
    ),
    en: (
      <>
        Generally, you are not required to provide us with your personal data
        when you visit our website www.getpopcard.com. However, there are
        certain exceptions. For certain services offered by our site, you may be
        required to provide specific data such as your name, job title, company
        name, email address, and phone number. This is the case when you fill
        out the online form in the "Contact" section. In all cases, you can
        refuse to provide your personal data. If you choose not to, you will not
        be able to use the site's services, including requesting information
        about our company or receiving newsletters. Finally, we may
        automatically collect certain information about you while simply
        browsing our website, specifically: information concerning your site
        usage, like the areas you visit, the services you access, your IP
        address, browser type, and access times. This information is used
        exclusively for internal statistics to improve the quality of services
        offered. The databases are protected under law 09-08 on personal data
        protection.
      </>
    ),
  },
};

export default confidentialityTranslation;
